/**
 * MetricShell — каркас метрик-карточки дашборда (шапка: подпись + иконка-чип,
 * тело). Иконку можно опустить (карточка «По рискам» рисует свою шапку).
 */

import type {ReactNode} from 'react';

type MetricShellProps = {
  label: ReactNode;
  icon?: ReactNode;
  iconClassName?: string;
  children: ReactNode;
};

export const MetricShell = ({label, icon, iconClassName, children}: MetricShellProps) => (
  <div className="flex min-h-[172px] flex-col rounded-[14px] border border-skr-line bg-card px-[19px] py-[18px] shadow-[0_1px_2px_rgba(20,25,40,.03)]">
    <div className="flex items-start justify-between">
      <div className="text-[12.5px] font-medium text-muted-foreground">{label}</div>
      {icon && (
        <div className={`grid size-[30px] shrink-0 place-items-center rounded-lg ${iconClassName}`}>
          {icon}
        </div>
      )}
    </div>
    {children}
  </div>
);
